export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'plot-analysis',
    name: '剧情解析',
    description: '深度剖析亲吻姐姐每一集的剧情发展、情感线索与故事脉络',
    icon: 'ri-movie-2-line',
    articleCount: 12,
  },
  {
    slug: 'characters',
    name: '角色介绍',
    description: '全面了解住之江亚香、理香、圭太等经典角色的魅力所在',
    icon: 'ri-user-heart-line',
    articleCount: 8,
  },
  {
    slug: 'voice-actors',
    name: '声优阵容',
    description: '揭秘亲吻姐姐背后豪华声优阵容的精彩演绎与幕后故事',
    icon: 'ri-mic-line',
    articleCount: 6,
  },
  {
    slug: 'ova',
    name: 'OVA特辑',
    description: '亲吻姐姐OVA全系列详解，从制作背景到画面细节全面解读',
    icon: 'ri-dvd-line',
    articleCount: 5,
  },
  {
    slug: 'iconic-scenes',
    name: '名场面回顾',
    description: '重温亲吻姐姐中最令人心动、最搞笑、最感动的经典名场面',
    icon: 'ri-heart-pulse-line',
    articleCount: 10,
  },
];